import "./ProductCardStyle.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addItem } from "../redux/cartListSlice";
import React from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "../assets/ReactToastify.css";

function ProductCard(product) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cartList = useSelector((state) => state.cartList);

  const [insufficientStock, setInsufficientStock] = React.useState(false);

  const stockVerification = async (slug) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/products/stock/${slug}`
      );
      const stock = response.data;
      return stock;
    } catch (err) {
      console.log(err.data);
    }
  };

  const handleProductClick = (e) => {
    // console.log(e.target.id);
    if (e.target.id !== "btn-add") navigate("/product/" + product.slug);
  };

  const handleAddToCart = async () => {
    const stock = await stockVerification(product.slug);
    const productInCart = cartList.some((item) => {
      return item.slug === product.slug;
    });
    if (!productInCart && stock > 1) {
      dispatch(addItem({ slug: product.slug, quantity: 1 }));
    } else {
      cartList.map((item) => {
        if (item.slug === product.slug && stock >= item.quantity + 1) {
          dispatch(addItem({ slug: product.slug, quantity: 1 }));
        } else {
          setInsufficientStock(true);
        }
      });
    }
    toast.success("Product added to cart", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  return (
    <div
      className="d-flex border border-box flex-column align-items-center justify-content-between mb-80 me-1 wow fadeInUp"
      style={{
        backgroundColor: "white",
        width: "16rem",
        height: "18rem",
        maxHeight: "18rem",
      }}
      onClick={handleProductClick}
    >
      <div className="" style={{ width: "100%", height: "8rem" }}>
        <img
          className=""
          style={{ height: "100%", objectFit: "cover" }}
          alt={product.slug}
          src={`../img/ProductImg2/${product.img}`}
          // src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/laderhack/products/${product.img}`
        />
      </div>
      <h5
        className="fs-6 fw-normal overflow-hidden"
        style={{ minHeight: "2.5rem" }}
      >
        {product.name}
      </h5>
      <div className="w-100 d-flex flex-column justify-content-center align-items-center">
        <p className="fs-6 fw-heavy p-0 m-0 mb-2">${product.price}</p>
        <button onClick={handleAddToCart} className="m-0 w-100" id="btn-add">
          Add to cart
        </button>
      </div>
    </div>
    // <div
    //   className="product-card border col mb-5 p-0 col-sd-6 wow fadeInUp"
    //   data-wow-duration="1"
    //   style={{ backgroundColor: "white" }}
    // >
    //   <div className="border-box p-0">
    //     <div className="img-box" onClick={handleProductClick}>
    //       <img className="img" alt="Producto" src={product.img} />
    //     </div>
    //     <h5 className="titulo">{product.name}</h5>
    //     <h4 className="precio">${product.price}</h4>
    //     <button className="button-agregar" id="btn-add">
    //       Agregar al carrito
    //     </button>
    //   </div>
    // </div>
  );
}
export default ProductCard;
